"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("core-js/modules/es6.regexp.split");
































































































































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      droplist: [], droplist2: [], newadd: false, newadd2: false, urlName: '', title: '', searchData: { otaVersion: '', enabled: '', isForce: '', deviceTypeId: '', // 固件类型 1:中心板 2:wifi板 3:讯飞中心板 4:非讯飞中心板
        firmwareType: '1', // 当前页码
        page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', name: '', otaVersion: '', enabled: '1', isForce: '0', firmwareDownloadType: '1', md5: '', path: '', urlList: [], remark: '', firmwareType: '1', // 固件类型1中心板2wifi板3讯飞中心板4非讯飞中心板
        url: '', url2: '', firmwareName: '' }, defaultData: { id: '', name: '', otaVersion: '', enabled: '1', isForce: '0', firmwareDownloadType: '1', md5: '', path: '', urlList: [], remark: '', firmwareType: '1', url: '', url2: '', firmwareName: '' }, rules: { otaVersion: [{ required: true, message: '请输入中心板版本', trigger: 'blur' }], isForce: [{ required: true, message: '请选择是否强制升级', trigger: 'blur' }], enabled: [{ required: true, message: '请选择是否启用', trigger: 'blur' }], urlList: [{ required: true, message: '请上传固件文件', trigger: 'change' }], firmwareDownloadType: [{ required: true, message: '请选择下载方式', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'firmwareName', label: '名称', isShow: false }, { prop: 'otaVersion', label: '中心版本', isShow: true }, { prop: 'deviceType', label: '设备类型', isShow: true }, { prop: 'firmwareDownloadType', label: '下载方式', formatter: _formatter.downloadTypeFormatter, isShow: true }, { prop: 'isForce', label: '是否强制升级', formatter: _formatter.isForceFormatter, isShow: true }, { prop: 'enabled', label: '是否启用', formatter: _formatter.statusFormatter, isShow: true }, { prop: 'remark', label: '备注', isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: true }] };}, mounted: function mounted() {var self = this;self.init();self.getdrop();}, methods: { init: function init() {var self = this;self.getData('/api/faOtaVersion', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, // 设置imageList
    setImageList: function setImageList(val) {var arr = [];if (val) {arr.push(val);}this.imageSrcList = arr;}, resetFun: function resetFun() {// 重置
      this.searchData.otaVersion = '';this.searchData.enabled = '';this.searchData.isForce = '';this.searchData.deviceTypeId = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;if (this.searchData.endTime) {var endTime = this.searchData.endTime;if (endTime.split(' ').length < 2) {endTime = endTime + ' 23:59:59';this.searchData.endTime = endTime;}}this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, getdrop: function getdrop() {var self = this;self.getData('/api/faDeviceType/getDownList', {}, function (res) {self.droplist = res;});}, getdrop2: function getdrop2() {var self = this;self.getData('/api/faDeviceType', { name: self.addData.name }, function (res) {self.droplist2 = res.list;});}, addFun: function addFun() {// 新增
      this.title = '新增';this.addData = JSON.parse(JSON.stringify(this.defaultData));this.newadd = true;
      this.getdrop2();
    },
    // changeproductFun: function(data) {
    //   let obj = {}
    //   obj = this.droplist2.find((item) => {
    //     return item.id === data
    //   })
    //   this.addData.name = obj.name
    //   this.addData.deviceTypeId = obj.id
    // },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();
      this.cleanData();
      this.newadd = false;
      this.newadd2 = false;
    },
    updateMenu: function updateMenu(item) {// 修改操作
      this.title = '修改';
      console.log('item', item);
      var self = this;
      self.addData = {
        id: item.id,
        deviceTypeId: item.deviceTypeId,
        enabled: item.enabled + '',
        isForce: item.isForce + '',
        firmwareDownloadType: item.firmwareDownloadType + '',
        otaVersion: item.otaVersion,
        remark: item.remark,
        firmwareType: '1',
        md5: item.md5,
        url2: item.url,
        path: item.url,
        urlList: [],
        firmwareName: item.firmwareName };

      self.addData.urlList.push(item.url);
      this.getdrop2();
      self.getUrlName(item.url);
      self.newadd = true;
    },
    onsuccess: function onsuccess(res) {
      console.log('res222', res);
      var self = this;
      self.addData.path = res.data.dir;
      // self.addData.md5 = res.data.md5
      // const url = res.data.url
      // self.addData.urlList.push(url)
      // self.getUrlName(url)
      if (self.addData.path === '') {
        console.log('res111', res);
        var url = res.url;
        // self.addData.path = res.data.dir
        self.addData.md5 = res.data.md5;
        self.addData.urlList.push(url);
        self.getUrlName(url);
        // param.onSuccess()
      } else {
        // formData.append('path', self.addData.path)
        console.log(res);
        var url2 = res.data.url;
        self.addData.md5 = res.data.md5;
        self.addData.path = res.data.dir;
        self.addData.url2 = res.data.url;
        self.addData.urlList.unshift(url2);
        self.getUrlName(url2);
        // param.onSuccess()
      }
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    // UploadImage(param) { // 上传文件
    //   const self = this
    //   const formData = new FormData()
    //   formData.append('file', param.file)
    //   if (self.addData.path === '') {
    //     self.postFormData('/api/faOtaVersion/upload', formData, function(res) {
    //       console.log('res111', res)
    //       const url = res.url
    //       self.addData.path = res.dir
    //       self.addData.urlList.push(url)
    //       self.$message({
    //         message: '添加成功!',
    //         type: 'success'
    //       })
    //       param.onSuccess()
    //     })
    //   } else {
    //     formData.append('path', self.addData.path)
    //     self.postFormData('/api/faOtaVersion/upload', formData, function(res) {
    //       console.log(res)
    //       const url = res.url
    //       self.addData.md5 = res.md5
    //       self.addData.path = res.dir
    //       self.addData.urlList.push(url)
    //       self.$message({
    //         message: '添加成功!',
    //         type: 'success'
    //       })
    //       param.onSuccess()
    //     })
    //   }
    // },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      var message = '添加成功!';
      if (self.title === '修改') {
        message = '修改成功!';
      }
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faOtaVersion', self.addData, function (res) {
            self.$message({
              message: message,
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/faOtaVersion/' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        enabled: '',
        isForce: '',
        firmwareDownloadType: '',
        otaVersion: '',
        remark: '',
        firmwareType: '3',
        md5: '',
        url2: '',
        path: '',
        firmwareName: '' };

      this.urlName = '';
    },
    openCopy: function openCopy(item) {
      var self = this;
      self.addData.url = item.url;
      self.newadd2 = true;
    },
    copyFun: function copyFun() {
      var url = document.querySelector('#copyObj');
      url.select(); // 选择对象
      document.execCommand('Copy');
      this.closeDiglog();
    },
    getUrlName: function getUrlName(url) {
      if (url) {
        var lastInfo = url.lastIndexOf('/');
        this.urlName = url.substring(lastInfo + 1);
      }
    },
    get: function get(event) {
      var self = this;
      if (event.keyCode == 38 || event.keyCode == 40) return;
      self.getdrop2();
    } } };exports.default = _default;